import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { HFSpinner } from '@hf/designSystem/v1';
import { useAccount } from '@core/utils/auth';
import { canManageCompany } from '@core/utils/auth/companyRole';
import { PATHS, privateNestedRoutes, publicRoutes, type SpaChildRoute } from '@core/routes';
import { RequireAuth } from './guards/RequireAuth';
import { RequireAdmin } from './guards/RequireAdmin';
import { AppLayout } from './layout/AppLayout';

function mapNestedChildren(children: SpaChildRoute[]) {
  return children.map((child) =>
    child.index ? <Route key="index" index element={child.element} /> : <Route key={child.path} path={child.path} element={child.element} />,
  );
}

export function App() {
  const { user } = useAccount();
  const companyAdmin = canManageCompany(user?.role);

  return (
    <Suspense fallback={<HFSpinner center sx={{ minHeight: '100vh' }} />}>
      <Routes>
        {publicRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}
        <Route element={<RequireAuth />}>
          <Route element={<AppLayout companyAdmin={companyAdmin} />}>
            {privateNestedRoutes.map((route) => {
              const spa = (
                <Route key={route.path} path={route.path} element={route.layout}>
                  {mapNestedChildren(route.children)}
                </Route>
              );
              // Always register gated routes so deep links hit RequireAuth and keep ?next=
              if (route.adminOnly) {
                return (
                  <Route key={route.path} element={<RequireAdmin />}>
                    {spa}
                  </Route>
                );
              }
              return spa;
            })}
          </Route>
        </Route>
        <Route path="*" element={<Navigate to={PATHS.home} replace />} />
      </Routes>
    </Suspense>
  );
}
